import { computed } from 'vue'
import { useAuth } from '@/composables/useAuth'

/**
 * True for the read-only `admin-viewer` role (see stores/auth.ts's UserRole
 * comment) — used purely for UI convenience (disabling buttons, showing a
 * banner) so the account isn't left clicking Save/Delete/etc. and getting a
 * raw permission-denied error. This is NOT the security boundary: every
 * actual write is already rejected server-side (firestore.rules/Cloud
 * Functions) regardless of what this returns, so a bug here can make the UI
 * misleading but can never let a view-only account actually write anything.
 */
export function useViewOnly() {
  const { role } = useAuth()
  const isViewOnly = computed(() => role.value === 'admin-viewer')
  return { isViewOnly }
}
